/* Vehicle -> vehicle collection lookup for the YMM selector.
   The lookup is no longer hard-coded here: it is built by the theme (vehicle-selector / custom-main-collection-banner sections)
   from each vehicle metaobject's "Vehicle collection" field (Shopify admin > Content > Metaobjects > Vehicle) and exposed as
   window.ymmVehicleMap = { "<vehicle metaobject numeric id>": "<collection handle>" }.
   Vehicles with no collection set fall back to the old behaviour (filter the make/current collection). */
(function () {
  var MAP = window.ymmVehicleMap || {};
  var UNIVERSAL_GID = 'gid://shopify/Metaobject/400891937093';
  var FILTER_PARAM = 'filter.p.m.custom.associated_vehicle';
  var handles = {};
  for (var k in MAP) { handles[MAP[k]] = true; }

  function currentHandle() {
    var p = window.location.pathname;
    var i = p.indexOf('/collections/');
    if (i === -1) return '';
    return p.slice(i + 13).split('/')[0];
  }

  window.ymm = {
    map: MAP,
    filterLimit: 5000, // native Shopify filtering stops working above this many products
    isVehicleCollectionHandle: function (h) { return !!handles[h]; },
    currentHandle: currentHandle,
    setCookie: function (id) {
      document.cookie = 'torque_mmy_metaobject=' + encodeURIComponent(id) + '; path=/; max-age=31536000; SameSite=Lax';
    },
    /* opts: vehicleId, make, productCount (current collection, 0 if none), onVehicleCollection (bool), makes (lowercase array) */
    destination: function (opts) {
      var id = String(opts.vehicleId);
      var handle = currentHandle();
      var onCollection = handle !== '';
      var vehicleHandle = MAP[id];
      var isMake = onCollection && opts.makes && opts.makes.indexOf(handle) !== -1;
      var tooBig = (opts.productCount || 0) > this.filterLimit;
      var onVehicle = !!opts.onVehicleCollection || (onCollection && !!handles[handle]);
      if (vehicleHandle && (!onCollection || isMake || tooBig || onVehicle)) {
        return { mode: 'collection', url: window.location.origin + '/collections/' + vehicleHandle, same: vehicleHandle === handle };
      }
      var url = onCollection
        ? new URL(window.location.origin + window.location.pathname)
        : new URL(window.location.origin + '/collections/' + encodeURIComponent((opts.make || 'all').toLowerCase()));
      url.searchParams.append(FILTER_PARAM, 'gid://shopify/Metaobject/' + id);
      url.searchParams.append(FILTER_PARAM, UNIVERSAL_GID);
      return { mode: 'filter', url: url.toString(), same: false };
    }
  };
})();
